import React from 'react';
import { Link } from 'react-router-dom';
import './DashboardHome.css';


class DashboardHome extends React.Component {

	render() {
		return (
			<div className="container page-dashboard">
				<div className="row">
					<div className="col-md-10 offset-md-1">

						<div className="card">
							<div className="card-block">
								<h2>Welcome to MyMHP</h2>
								<p style={{fontSize: 18}}>
									MyMHP is your mental health 'passport' to help you provide clear, consistent information to mental health service providers and professionals.
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-md-12 offset-md-2">
						<div className="row">
							<div className="col-md-4">
								<div className="card">
									<div className="card-block text-center">
									<Link to={'/passport'} style={{color: `#555`}}>
										<img src="/assets/img/icon-passport.svg" className="img-responsive" style={{maxHeight: 150, marginTop: `2em`}} alt="Passport"/>
										<p className="mt-4">Create/Edit your Passport</p>
									</Link>
									</div>
								</div>
							</div>
							<div className="col-md-4">
								<div className="card">
									<div className="card-block text-center">
									<Link to={'/advice'} style={{color: `#555`}}>
										<img src="/assets/img/icon-signpost.svg" className="img-responsive" style={{maxHeight: 150, marginTop: `2em`}} alt="Mental Health Advice"/>
										<p className="mt-4">Get Help &amp; Advice</p>
									</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}




export default DashboardHome;



// WEBPACK FOOTER //
// ./src/js/components/DashboardHome/DashboardHome.js